import {
    SUCCESS_CATALOG,
    SUCCESS_LOCALITY
} from '../actions/action-types'

const initialState = {
    region: [],
    locality: []
}

export default function(state = initialState, action) {
    switch (action.type) {
        case SUCCESS_CATALOG:
            return Object.assign({}, state, {
                ...action.payload
            })
        case SUCCESS_LOCALITY:
            return {
                ...state,
                locality: action.payload
            }
      default:
        return state;
    }
  }